module.exports = __webpack_public_path__ + "static/img/xwjg_bg.c8042eb3.png";